import Confirm from './confirm/ConfirmEmail';
import ResendConfirm from './resend/ResendConfirmEmail';

export default {Confirm, ResendConfirm}